"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_DACS_USERNAME = void 0;
exports.DEFAULT_DACS_USERNAME = 'user';
